import StatusBadge from "../../common/helper/transaction-status.component.js";

export const bankingPartnersColumns = (onEdit, onToggleStatus, onDelete) => [
  {
    name: "Partner Name",
    selector: (row) => row.partner_name,
    sortable: true,
  },
  {
    name: "Partner Type",
    cell: (row) => (
      <div style={{ display: "flex", gap: "6px" }}>
        {row.supports_payin && (
          <span
            className="badge badge-pill"
            style={{
              backgroundColor: "#28a745",
              color: "white",
              fontSize: "11px",
              padding: "4px 10px",
            }}
          >
            Payin
          </span>
        )}
        {row.supports_payout && (
          <span
            className="badge badge-pill"
            style={{
              backgroundColor: "#dc3545",
              color: "white",
              fontSize: "11px",
              padding: "4px 10px",
            }}
          >
            Payout
          </span>
        )}
      </div>
    ),
    sortable: true,
  },
  {
    name: "Status",
    cell: (row) => (
      <span
        className={`badge badge-pill ${row.is_active ? 'badge-success' : 'badge-secondary'}`}
      
      >
        {row.is_active && (
          <span
            className="badge badge-pill"
            style={{
              backgroundColor: "#28a745",
              color: "white",
              fontSize: "11px",
              padding: "4px 10px",
            }}
          >
            Active
          </span>
        )}
         {!row.is_active && (
          <span
            className="badge badge-pill"
            style={{
              backgroundColor: "#dc3545",
              color: "white",
              fontSize: "11px",
              padding: "4px 10px",
            }}
          >
            Inactive
          </span>
        )}
      </span>
    ),
    sortable: true,
  },
  {
    name: "Actions",
    cell: (row) => (
      <div style={{ display: "flex", gap: "8px" }}>
        <a
          className="flock tooltip"
          style={{ cursor: "pointer" }}
          onClick={() => onToggleStatus(row)}
        >
          <i className={row.is_active ? "fa fa-lock" : "fa fa-unlock"} />
          <span className="tooltiptext">
            {row.is_active ? "Deactivate" : "Activate"}
          </span>
        </a>
        
        <a
          className="ftrash tooltip"
          style={{ cursor: "pointer" }}
          onClick={() => onDelete(row)}
        >
          <i className="fa fa-trash" />
          <span className="tooltiptext">Delete</span>
        </a>
      </div>
    ),
  },
];
